import { CardHeader } from '@material-ui/core';
import React, { useState } from 'react'
import { List, Datagrid, TextField, ReferenceField } from 'react-admin';
import SearchInput from '../SearchInput';
import { StatusField } from './MachinesStatus';
import MacActionMenu from './MacActionMenu';

const MachinesList = ({ macList, actions, clientId, isAdmin, ...props }) => {
    const searchFilters = (
        <SearchInput 
            searchKeys={["machineUUID", "location", "versionName"]} 
        />
    );

    let filter = {};
    if(clientId) {
        filter = {
            "client.id": clientId,
        }
    }
    
    return (
        <>
            <div className="listMachines" style={{ width: "90%" }}>
                <CardHeader title="List Machines" />
                    <>
                        {/* <List
                            {...props}
                            resource="machines"
                            basePath="/machines"
                            actions={actions}
                            filter={{ "client.id": clientId }}
                            data={macList}
                            filters={searchFilters}
                            bulkActionButtons={false}
                            perPage={25}
                        >
                            <Datagrid data={filteredData} {...props} bulkActionButtons={false} sx={{ '& .RaDatagrid-headerCell': { fontWeight: 'bold' } }}>
                                <TextField 
                                    source="machineUUID"
                                    label="UUID"
                                />
                                <TextField 
                                    source="location"
                                    label="Location"
                                />
                                {isAdmin && (
                                    <ReferenceField label="Company" source="client.id" reference="clients" link={false}>
                                        <TextField source="companyName" />
                                    </ReferenceField>
                                )}
                                <StatusField label="Status" />
                                <TextField
                                    source="versionName"
                                />
                                <MacActionMenu label="Actions" />
                            </Datagrid>
                        </List> */}
                        <List
                            {...props}
                            resource="machines"
                            actions={actions}
                            filter={filter}
                            filters={searchFilters}
                            sort={{ field: 'createdAt', order: 'DESC' }}
                            perPage={25}
                            empty={false}
                        >
                            <Datagrid 
                                bulkActionButtons={false} 
                                sx={{ 
                                    '& .RaDatagrid-headerCell': { fontWeight: 'bold' },
                                    minWidth: '1200px',
                                    tableLayout: 'fixed',
                                    '& .RaDatagrid-headerCell:nth-of-type(1), & .RaDatagrid-rowCell:nth-of-type(1)': {
                                        width: '20px',
                                    },
                                    '& .RaDatagrid-headerCell:nth-of-type(2), & .RaDatagrid-rowCell:nth-of-type(2)': {
                                        width: '250px',
                                    },
                                    '& .RaDatagrid-headerCell:nth-of-type(3), & .RaDatagrid-rowCell:nth-of-type(3)': {
                                        width: '150px',
                                    },
                                    '& .RaDatagrid-headerCell:nth-of-type(4), & .RaDatagrid-rowCell:nth-of-type(4)': {
                                        width: '150px',
                                    },
                                    '& .RaDatagrid-headerCell:nth-of-type(5), & .RaDatagrid-rowCell:nth-of-type(5)': {
                                        width: '120px',
                                    },
                                    '& .RaDatagrid-headerCell:nth-of-type(6), & .RaDatagrid-rowCell:nth-of-type(6)': {
                                        width: '150px',
                                    },
                                    '& .RaDatagrid-headerCell:nth-of-type(7), & .RaDatagrid-rowCell:nth-of-type(7)': {
                                        width: '130px',
                                    },
                                    '& .RaDatagrid-headerCell:nth-of-type(8), & .RaDatagrid-rowCell:nth-of-type(8)': {
                                        width: '130px',
                                    },
                                    '& .RaDatagrid-headerCell:nth-of-type(9), & .RaDatagrid-rowCell:nth-of-type(9)': {
                                        width: '100px',
                                    },
                                    '& .RaDatagrid-headerCell:nth-of-type(10), & .RaDatagrid-rowCell:nth-of-type(10)': {
                                        width: '80px',
                                    },
                                }}
                            >
                                <TextField label="Machine UUID" source="machineUUID" />
                                <TextField label="Location" source="location" />
                                {isAdmin && (
                                    <ReferenceField label="Company" source="client.id" reference="clients" link={false}>
                                        <TextField source="companyName" />
                                    </ReferenceField>
                                )}
                                <StatusField
                                    label="Status"
                                    render={(record) => record.status?.online ? "Online" : "Offline"}
                                />
                                <TextField label="Version" source="versionName" />
                                <MacActionMenu label="Actions" />
                            </Datagrid>
                        </List>
                    </>
            </div>
        </>
    )
}

export default MachinesList;
